import { Storage } from "./storage";
import { FormTemplate } from "./template";
import { User } from "./user";

export interface SpreadsheetConversion {
    id?: number;
    
    path: string;
    
    storage_id: number;
    storage: Storage;
    
    user_id: number;
    user: User;
    
    selected_worksheet?: string;
    
    form_template_id: number;
    form_template: FormTemplate;
    
    assigned_datetime?: Date;
    assigned_datetime_column_index?: number;

    /** @note columns_info is different than ColumnInfo returned when getting the info of a spreadsheet pre-conversion */
    columns_info: any;
    column_headers: string[];

    total_rows: number;
    rows_processed: number;
    status: SpreadsheetConversionStatus;

    conversion_errors_count?: number;

    submission_name_column_index?: number;
    timezone?: string;
}

export enum SpreadsheetConversionStatus {
    STATUS_PENDING = 1,
    STATUS_IN_PROGRESS = 2,
    STATUS_COMPLETED = 3,
    STATUS_DELETING = 4
}
export interface ColumnInfo {
    index: number;
    header: string;
    sample_data: any[];
}

export interface SheetInfo {
    name: string;
    total_columns: number;
    total_rows: number;
    columns: ColumnInfo[];
}

export interface SpreadsheetInfo {
    path: string;
    sheets: SheetInfo[];
}

export interface ColumnConversionParams {

    // for form creation
    skip_field_creation: boolean;
    label: string;
    form_field_type: string;

    // for data import
    form_field_key: string;
    add_new_options?: boolean;

    is_required?: boolean;
    skip_data_import?: boolean;

    checkbox_true_value?: string;
}

export interface SpreadsheetConversionParams {
    path: string;
    
    storage_id: number;

    selected_worksheet: string;

    // For form creation
    form_dest_path?: string;
    form_name?: string;
    index_basename?: string;

    submission_name_column_index: number;

    assigned_datetime?: Date;
    assigned_datetime_column_index?: number;

    timezone: string;
    column_headers: string[];
        
    columns: ColumnConversionParams[];
}